module.exports = __webpack_public_path__ + "img/playr.42f396ec.png";